    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            departments: null,
            departmentFree: null,
            loadingData: null
        }
    }
    
    const state = getDefaultState()

    const getters = {
        departments: state => {
            return state.departments
        },
        loadingData: state => {
            return state.loadingData
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        departments: (state, payload) => {
            state.departments = payload
        },
        departmentsFree: (state, payload) => {
            state.departmentsFree = payload
        },
        loadingData: (state, payload) => {
            state.loadingData = payload
        },
    }

    const actions = {
       
        getDepartments: ({commit, dispatch}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/departments/' + payload._id)
            .then(
                res => {
                    commit('updating', false)
                    commit('departments', res.data)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                    if(error.response){
                        if(error.response.status == 401) dispatch('logout')
                    }
                }
              )
        },

        postDepartment ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/departments', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getCompany')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateShiftmodelsDepartment: ({commit}, payload) => {
            commit('loadingData', true)
            commit('updating', true)
            axiosAuth.patch('/departments/'+ payload._id, payload)
            .then(
                res => {
                    commit('loadingData', false)
                    commit('trash', res)
                    commit('updating', false)
                }
              )
            .catch(
                error => {
                    commit('loadingData', false)
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }